import {
  findBoxesByCareUnitId,
  findBoxSettingsBySCStationId,
} from "../api/SCStationAPI";
import { Actions } from "../components/Store/Reducer";
import Messages from "../Messages";

export function throwError(errorCode, intl) {
  if (errorCode && Messages[`Text_ErrorMessage_${errorCode}`]) {
    throw new Error(
      intl.formatMessage(Messages[`Text_ErrorMessage_${errorCode}`])
    );
  } else {
    throw new Error(intl.formatMessage(Messages["Text_ErrorMessage"]));
  }
}

export async function loadControlBoxesAndSettings({
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) {
  if (!store || !store.scStation || !store.scStation.careUnitId) return;
  const boxes = await findBoxesByCareUnitId({
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
  const settings = await findBoxSettingsBySCStationId({
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
  if (boxes) dispatch({ type: Actions.SetControlBoxes, payload: boxes });
  if (settings) dispatch({ type: Actions.SetBoxSettings, payload: settings });
}

export async function loadBoxes({
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) {
  if (!store || !store.scStation || !store.scStation.careUnitId) return;
  const boxes = await findBoxesByCareUnitId({
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
  if (boxes) {
    dispatch({
      type: Actions.SetControlBoxes,
      payload: boxes,
    });
  }
}
